import {
  GetDoctorWorkScheduleListActionTypes,
  GET_DOCTOR_SCHEDULE_LIST_FAIL,
  GET_DOCTOR_SCHEDULE_LIST_LOADING,
  GET_DOCTOR_SCHEDULE_LIST_SUCCESS,
  GetDoctorWorkScheduleListState,
  GET_DOCTOR_SCHEDULE_LIST_UPDATE_API_MSG,
  GET_DOCTOR_SCHEDULE_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetDoctorWorkScheduleListRes } from "./Model";

const initialStateGetPosts: GetDoctorWorkScheduleListState = {
  loading: false,
  getDoctorWorkScheduleListRes: {} as GetDoctorWorkScheduleListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getDoctorWorkScheduleListReducer = (
  state = initialStateGetPosts,
  action: GetDoctorWorkScheduleListActionTypes
): GetDoctorWorkScheduleListState => {
  switch (action.type) {
    case GET_DOCTOR_SCHEDULE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_DOCTOR_SCHEDULE_LIST_SUCCESS:
      return {
        ...state,
        getDoctorWorkScheduleListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_DOCTOR_SCHEDULE_LIST_FAIL:
      return {
        ...state,
        getDoctorWorkScheduleListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_SCHEDULE_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getDoctorWorkScheduleListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_SCHEDULE_LIST_UPDATE_API_RES:
      return {
        ...state,
        getDoctorWorkScheduleListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
